import { useState } from "react";
import { DRow } from "./DRow";
import React from "react";
import { dcolors } from "corexxx";

// Use for two panel view and two panel indipendly scroll
// Note that you can drag the left pane
export function DTwoPaneView({
  left,
  right,
  width,
}: {
  left: any;
  right: any;
  width?: number;
}) {
  const [leftWidth, setLeftWidth] = useState(width || 400); // Initial width for the left pane
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = () => {
    setIsDragging(true);
    document.body.style.userSelect = "none";
  };

  const handleMouseMove = (e: any) => {
    if (!isDragging) return;
    const newWidth = e.clientX; // New width based on mouse position
    if (newWidth > 50 && newWidth < window.innerWidth - 50) {
      setLeftWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    document.body.style.userSelect = ""; // Re-enables text selection
  };

  React.useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  return (
    <DRow style={{ height: "100%" }}>
      <div
        style={{
          background: dcolors.pallets.grey200,
          width: leftWidth,
          padding: 20,
          overflow: "scroll",
          height: "100%",
        }}
      >
        {left}
      </div>
      <div
        id="resizer"
        style={{
          width: "8px",
          backgroundColor: "#ddd",
          cursor: "ew-resize",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "30px",
          fontWeight: "bold",
          color: "#666",
        }}
        onMouseDown={handleMouseDown}
      >
        {" "}
        ⋮
      </div>
      <div
        style={{
          width: `calc(100% - ${leftWidth}px - 20px)`,
          paddingLeft: 10,
          overflow: "scroll",
          maxHeight: "100%",
        }}
      >
        {right}
      </div>
    </DRow>
  );
}
